import type { TAutocompleteOption } from '~/components/AutocompleteField/types.ts';
import { normalizeEmail } from '../utils.ts';

export { normalizeEmail };

export const buildEmailOptions = (
  supervisorEmails: readonly string[] = [],
  currentEmail?: string | null
): TAutocompleteOption[] => {
  const emails = new Set(
    [...supervisorEmails, normalizeEmail(currentEmail)].map((email) => email.trim()).filter(Boolean)
  );

  return Array.from(emails).map((email) => ({
    label: email,
    value: email,
  }));
};
